import { NavLink, Link as RouterLink } from 'react-router-dom';

import { Breadcrumb as BreadcrumbUI, DropdownMenu, MoreButton } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  currentPage?: string;
}

export function Breadcrumb({ currentPage }: Props) {
  const { t } = useTranslation();

  if (!currentPage) {
    return (
      <BreadcrumbUI aria-label={t('common.breadcrumbs')}>
        <NavLink to="..">{t('common.settings')}</NavLink>
        <a aria-current="page">{t('common.carrierContracts')}</a>
      </BreadcrumbUI>
    );
  }

  return (
    <BreadcrumbUI aria-label={t('common.breadcrumbs')}>
      <DropdownMenu.Root modal={false}>
        <DropdownMenu.Trigger>
          <MoreButton style={{ display: 'inline', verticalAlign: 'top' }} />
        </DropdownMenu.Trigger>

        <DropdownMenu.Content align="start" sideOffset={6} style={{ minWidth: 140, width: 'auto' }}>
          <DropdownMenu.Item asChild>
            <RouterLink to="../..">{t('common.settings')}</RouterLink>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>

      <NavLink to="..">{t('common.carrierContracts')}</NavLink>

      <span aria-current="page">{currentPage}</span>
    </BreadcrumbUI>
  );
}
